//pc
    if (window.innerWidth >= 1024){
        let sliderPos;
        let showValue;
        var slidingContrastChartWidth = $(".slidingContrastChart-pictureDiv").css('width');
        $(document).ready(function() {
            $(".slidingContrastChart-pictureDiv").css('height',$(".slidingContrastChart-textDiv").css('height'));
        })
        $(".slidingContrastChart-slider").on("input", function(e) {

            sliderPos = +$(".slidingContrastChart-slider").val();

            if (sliderPos <= 50){
                showValue = parseFloat(Math.abs((sliderPos - 50) / 100).toFixed(1)) + parseFloat(1);
                $(".slideValue").text('f ' + showValue.toFixed(1));
            }else {
                showValue = parseFloat(Math.abs((sliderPos - 50) / 50).toFixed(1)) + parseFloat(1);
                $(".slideValue").text('f ' + showValue.toFixed(1));
            }
            var brightness;
            if (( Math.abs( showValue - 2)) > 0.2){
                brightness =  Math.abs(showValue - 2);
            }else {
                brightness = 0.2;
            }

            // $(".slidingContrastChart-image").css('filter','grayscale('+(1 - sliderPos / 100 ).toFixed(1)+') sepia('+(1 - sliderPos / 100 ).toFixed(1)+')  blur(' + Math.floor(10 - sliderPos / 10 )+'px)');
            // $(".slidingContrastChart-image").css('filter','grayscale('+(1 - sliderPos / 100 ).toFixed(1)+') sepia('+( 1- sliderPos / 100 ).toFixed(1)+') brightness('+brightness+')');
            // $(".slidingContrastChart-slider-button").css("left",'calc(' + parseInt(slidingContrastChartWidth) * (sliderPos / 100) + 'px - 4.8rem)') ;
            // $(".slidingContrastChart-foreground-img").css("width", 92.8 * (sliderPos / 100)  +"rem");

            $(".slidingContrastChart-image").css('filter','grayscale('+(Math.abs(1 - showValue) )+') sepia('+( Math.abs(1 - showValue) )+') brightness('+brightness+')');
            $(".slidingContrastChart-slider-button").css("left",'calc(' + $(".slidingContrastChart-pictureDiv").outerWidth() * (sliderPos / 100) + 'px - 4.8rem)');
        });

        $(window).on('resize', function () {
            $(".slidingContrastChart-pictureDiv").css('height',$(".slidingContrastChart-textDiv").css('height'));
            slidingContrastChartWidth = $(".slidingContrastChart-pictureDiv").css('width');
        })

    }